import React, { useContext } from 'react'
import { Col } from '@microfrontends/react-components'
import {
	CompanionBusinessContainer,
	TitleSubText,
	CompanionBusinessCardWrapper
} from './styles'
import PageTitle from '../../components/PageTitle'
import AppContext from '../../../../context/AppContext'
import CompanionBusinessCard from './CompanionBusinessCard'
import { EDevice } from '../../../../containers/MainLayout'

export default function CompanionBusiness({companies}: {companies: any[]}) {
	const { data, breakpoint } = useContext(AppContext)
	return (
		<CompanionBusinessContainer container={{ lg: 12 }} gutter={[16, 0]}>
			<Col>
				<PageTitle id={'top-university'}
					subItem={
						<TitleSubText>
							VietnamWorks đồng hành cùng Top University nâng cao chất lượng nguồn nhân lực Việt
						</TitleSubText>
					}
				>
					Đồng hành cùng Top University
				</PageTitle>
			</Col>
			<Col>
				<CompanionBusinessCardWrapper>
					{data.companionBusiness.map(
						(item: {
							companyName: string
							companyLogo: string
							companyId: number
              description: string
						}) => (
							<CompanionBusinessCard
								numsOfItem={
									breakpoint === EDevice.LAPTOP
										? 6
										: breakpoint === EDevice.TABLET
										? 4
										: breakpoint === EDevice.MOBILE
										? 4
										: 9
								}
								key={item.companyName}
								data={item}
							/>
						)
					)}
				</CompanionBusinessCardWrapper>
			</Col>
		</CompanionBusinessContainer>
	)
}
